import { __assign, __rest } from "tslib";
// DS2.5
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import { IconSize } from '../../Icons/IconWrap';
import s from './IconButton.scss';
var IconButton = function (_a) {
    var size = _a.size, className = _a.className, IconComponent = _a.icon, _b = _a.variant, variant = _b === void 0 ? 'main' : _b, props = __rest(_a, ["size", "className", "icon", "variant"]);
    return (React.createElement(PlainButtonOrLink, __assign({ className: classnames(className, s['root'], s["size-".concat(size)], variant && s["variant-".concat(variant)], props.disabled && s['disabled']) }, props),
        React.createElement(IconComponent, { className: s['icon'], size: size === 'small' ? IconSize.SMALLER : IconSize.MEDIUM, disableDefaultColors: true })));
};
IconButton.displayName = 'IconButton';
export default IconButton;
//# sourceMappingURL=IconButton.js.map